import { currencyBRL } from './currencyBRL';
import { ICheckoutResponse } from '../../../../../store/ducks/order-simulate-checkout-mvp/types';
import { currencyFormatter } from './formatterHelper';

export const displayTaxes = (data: ICheckoutResponse | null) => {
  const zeroBRL = currencyFormatter({ amount: 0, currency: currencyBRL });
  const taxes = [
    {
      title: 'ICMS',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.icms ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'PIS',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.pis ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'COFINS',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.cofins ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'IPI',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.ipi ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'ST',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.icms_st ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'FCP',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.fcp ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'DIFAL',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.difal ?? '0'),
        currency: currencyBRL
      })
    }
  ];
  return taxes.filter((taxe) => taxe.value !== zeroBRL);
};
